/**
 * Absolute URL for displaying a user's profile photo.
 * Prefer `profileImage` (`/uploads/...`, served by Nginx in production), then legacy URLs, then avatar.
 *
 * @param {object | null | undefined} user
 * @param {string} [siteOrigin] from `/api/public-config` (no trailing slash)
 * @param {number | string} [cacheBust] optional query `v` for cache invalidation after upload
 */
export function resolveProfileDisplaySrc(user, siteOrigin = '', cacheBust) {
  if (!user) return '';

  if (user.profileImage && String(user.profileImage).startsWith('/uploads/')) {
    const origin = (siteOrigin || (typeof window !== 'undefined' ? window.location.origin : '') || '').replace(
      /\/$/,
      '',
    );
    const base = origin ? `${origin}${user.profileImage}` : user.profileImage;
    if (cacheBust != null && cacheBust !== '') {
      const sep = base.includes('?') ? '&' : '?';
      return `${base}${sep}v=${cacheBust}`;
    }
    return base;
  }

  if (user.profileImageUrl) return user.profileImageUrl;
  if (user.avatar) return user.avatar;
  return '';
}

/**
 * For flat strings (e.g. inbox `senderAvatar`): Nginx paths need an origin; full URLs pass through.
 */
export function resolveAvatarUrlString(raw, siteOrigin = '') {
  if (!raw) return '';
  if (raw.startsWith('/uploads/')) {
    const origin = (siteOrigin || (typeof window !== 'undefined' ? window.location.origin : '') || '').replace(
      /\/$/,
      '',
    );
    return origin ? `${origin}${raw}` : raw;
  }
  return raw;
}
